import VarIcon from '../icon';
import { computed, defineComponent } from 'vue';
import { props } from './props';
import { toNumber } from '../utils/shared';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vShow as _vShow, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = n => (_pushScopeId(""), n = n(), _popScopeId(), n);

var _hoisted_1 = {
  class: "var-badge var--box"
};
var _hoisted_2 = {
  key: 1
};
export function render(_ctx, _cache) {
  var _component_var_icon = _resolveComponent("var-icon");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_Transition, {
    name: "var-badge-fade"
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("span", _mergeProps(_ctx.$attrs, {
      class: ["var-badge__content", _ctx.contentClass],
      style: {
        background: _ctx.color
      }
    }), [_ctx.icon && !_ctx.dot ? (_openBlock(), _createBlock(_component_var_icon, {
      key: 0,
      name: _ctx.icon,
      size: "10px"
    }, null, 8
    /* PROPS */
    , ["name"])) : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.values), 1
    /* TEXT */
    ))], 16
    /* FULL_PROPS */
    ), [[_vShow, !_ctx.hidden]])]),
    _: 1
    /* STABLE */

  }), _renderSlot(_ctx.$slots, "default")]);
}
export default defineComponent({
  render,
  name: 'VarBadge',
  components: {
    VarIcon
  },
  inheritAttrs: false,
  props,

  setup(props, _ref) {
    var {
      slots
    } = _ref;
    var contentClass = computed(() => {
      var {
        type,
        position,
        dot,
        icon
      } = props;
      var positionBasic = (slots.default == null ? void 0 : slots.default()) && "var-badge__position var-badge--" + position;
      var dotClass = dot && 'var-badge__dot';
      var positionClass = getPositionClass();
      var iconClass = icon && 'var-badge__icon';
      return ["var-badge--" + type, positionBasic, dotClass, positionClass, iconClass];
    });
    var values = computed(() => {
      var {
        dot,
        value,
        maxValue
      } = props;
      if (dot) return '';
      if (value !== undefined && maxValue !== undefined && toNumber(value) > maxValue) return maxValue + "+";
      return value;
    });

    var getPositionClass = () => {
      var {
        position,
        dot
      } = props;
      if (dot && position.includes('right')) return 'var-badge__dot--right';
      if (dot && position.includes('left')) return 'var-badge__dot--left';
    };

    return {
      values,
      contentClass
    };
  }

});